import { useState } from "react";
import { useSelector } from "react-redux";

import draftLocked from "../../../public/BP_resources/images/icon/locked.svg";
import locked from "../../../public/BP_resources/images/icon/addcheck.svg";
import unlocked from "../../../public/BP_resources/images/icon/unlocked.svg";
import lockedGrey from "../../../public/BP_resources/images/icon/addcheck.svg";
import unlockedGrey from "../../../public/BP_resources/images/icon/unlocked-grey.svg";
import EditFeesPopup from "../Modals/EditFeesPopup";
import CheckAlreadyRequestedModal from "../CostDashboard/CheckAlreadyRequested";
import { currencyFormat, formatDate } from "../../Utils/helper";
import SettlementErrorModal from "../Modals/SettlementErrorModal";
import SettlementNoCheckModal from "../Modals/SettlementNoCheckModal";
import SettlementCheckRequest from "../Modals/SettlementCheckRequest";
import GenericSettlementAddPopup from "../Modals/GenericSettlementAddPopup";
import UserChatBubble from "../Forms/FirmUserBtn";

import updateLockSettleValue from "./common/updateLockSettleValue";
import updateLockSettleAmount from "./common/updateLockSettleAmount";
import AllLockSettle from "./common/AllLockSettle";
import ChequeUpload from "./ChequeUpload";
import SectionActionBar from "./SectionActionBar";
import updateRightColumnValue from "./common/updateRightColumnValue";
import CopyValueSettlement from "./common/CopyValueSettlement";
import SettlementCheckDetails from "./common/SettlementCheckDetails";
import SettlementCurrencyInput, {
  getSettlementCurrencyInputSum,
} from "./common/SettlementCurrencyInput";
import { hasNonZeroSettlementAmount, hasSettlementCheck } from "./common/settlementCheckGuards";

const OffersFeeTable = ({ clientProceeds, feesObj, settlementObjProps, initialOffers }) => {
  // const [isHovered, setIsHovered] = useState({ id: -1, value: false });
  const userOnlineStatus = useSelector((state) => state.chat2.userOnlineStatus);
  // const caseSummary = useSelector((state) => state?.caseData?.summary);
  const [showSettlementPopup, setShowSettlementPopup] = useState(false);
  const { updateClientProceedsState } = clientProceeds;
  const lockAllFees = (bType, boolVal) => {
    AllLockSettle("fees", bType, boolVal);
    if (bType === "draft1") {
      setFeesLocks((prevStates) =>
        prevStates.map((row) => ({
          ...row,
          isDraftLocked: hasSettlementCheck(row) ? row.isDraftLocked : boolVal === "true",
        }))
      );
    } else {
      setFeesLocks((prevStates) =>
        prevStates.map((row) => ({
          ...row,
          isFinalLocked: row.checkID ? row.isFinalLocked : boolVal === "true",
        }))
      );
    }
  };
  const page_id_click_record = useSelector(
    (state) => state.page_id_click_record.page_id_click_record
  );
  const handleDraftLockChange = (id, sectionName, event) => {
    event.stopPropagation();
    const lock = feesLocks.find((row) => row.id === id);
    if (hasSettlementCheck(lock)) {
      handleCheckedRowClick(event);
      return;
    }
    updateLockSettleValue(id, "fees", "draft1");
    setFeesLocks((prevStates) =>
      prevStates.map((row) => (row.id === id ? { ...row, isDraftLocked: !row.isDraftLocked } : row))
    );
  };
  const [modalAction, setModalAction] = useState("");
  const [errorMsg, _setMsgError] = useState("");
  const [showNoCheckModal, setNoCheckModal] = useState(false);
  const handleNoCheckClose = () => setNoCheckModal(false);
  const handleNoCheckShow = () => setNoCheckModal(true);
  const [checkAlreadyRequested, setCheckAlreadyRequested] = useState(false);
  const handleCheckAlreadyRequestedClose = () => setCheckAlreadyRequested(false);
  const handleCheckedRowClick = (event) => {
    event?.stopPropagation();
    setCheckAlreadyRequested(true);
  };

  const [showCheckRequestModal, setCheckRequestModal] = useState(false);
  const handleCheckRequestClose = () => setCheckRequestModal(false);

  const handleFinalLockChange = (id, sectionName, event) => {
    event.stopPropagation();
    const lock = feesLocks.find((row) => row.id === id);
    if (hasSettlementCheck(lock)) {
      handleCheckedRowClick(event);
      return;
    }
    updateLockSettleValue(id, "fees", "final");
    setFeesLocks((prevStates) =>
      prevStates.map((row) => (row.id === id ? { ...row, isFinalLocked: !row.isFinalLocked } : row))
    );
  };
  const {
    feesLocks,
    setFeesLocks,
    fees,
    feesPercentages,
    setFees,
    feesFinalAmount,
    feesLockValues,
    showFeeModal,
    setFeesLockValues,
    handleFeeClose,
    handleFeeShow,
    currentFee,
    setCurrentFee,
    feesCombinationList,
    currentCombination,
    setCurrentCombination,
    showErrorModal,

    handleErrorClose,
    handleErrorShow: _handleErrorShow,
    updateFeesState,
  } = feesObj;
  let offer_num = 1;
  return (
    <>
      <div className="m-b-5">
        <SectionActionBar sectionName={"Fees"} />
        <div className="table--no-card rounded-0 border-0 w-100">
          <table className="table table-borderless table-striped table-earning settlement-table">
            <thead>
              <tr id="settle-tb-header" className="settle-t-4 cursor-default">
                <th className="" />
                <th className="td-autosize text-center">Added</th>
                {/* <th className=""></th> */}
                <th className="text-center" colSpan={5}>
                  Negotiating Party
                </th>
                {/* <th className="td-autosize"></th> */}
                {/* <th className="td-autosize text-end">Fee</th> */}
                <th className="td-autosize text-center">Note</th>
                <th className="" />
                <th className="" />
                <th
                  className={`td-autosize text-end ${feesLocks?.some((lock) => !lock.isDraftLocked && !hasSettlementCheck(lock)) ? "cursor-pointer" : ""}`}
                  // style={{color:"var(--primary-25) !important"}}
                  onClick={() => {
                    const draftLockCheck = feesLocks?.some(
                      (lock) => !lock.isDraftLocked && !hasSettlementCheck(lock)
                    );
                    if (draftLockCheck) {
                      feesLocks?.forEach((fee, index) => {
                        if (!fee.isDraftLocked && !hasSettlementCheck(fee)) {
                          updateRightColumnValue(
                            fee.isDraftLocked,
                            fee.isFinalLocked,
                            setFeesLocks,
                            "fee-draft",
                            fee.id,
                            feesLockValues,
                            setFeesLockValues,
                            "fees",
                            "draft1",
                            fees[index].final_amount
                          );
                        }
                      });
                      updateFeesState();
                      updateClientProceedsState();
                    }
                  }}
                >
                  <span className="d-flex align-items-center justify-content-end position-relative center-val-div">
                    {feesLocks?.some(
                      (lock) => !lock.isDraftLocked && !hasSettlementCheck(lock)
                    ) && <CopyValueSettlement />}
                    Fee
                  </span>
                </th>
                <th
                  className={`s-draft text-end ${feesLocks?.some((lock) => lock.isDraftLocked && !lock.isFinalLocked && !hasSettlementCheck(lock)) ? "cursor-pointer" : ""}`}
                  style={{ color: "var(--primary-25) !important" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    const finalLockCheck = feesLocks?.some(
                      (lock) =>
                        lock.isDraftLocked && !lock.isFinalLocked && !hasSettlementCheck(lock)
                    );
                    if (finalLockCheck) {
                      feesLocks?.forEach((fee) => {
                        if (fee.isDraftLocked && !fee.isFinalLocked && !hasSettlementCheck(fee)) {
                          updateRightColumnValue(
                            fee.isDraftLocked,
                            fee.isFinalLocked,
                            setFeesLocks,
                            "fee-final",
                            fee.id,
                            feesLockValues,
                            setFeesLockValues,
                            "fees",
                            "final",
                            fee.isDraftAmount
                          );
                        }
                      });
                      updateClientProceedsState();
                    }
                  }}
                >
                  <div className="central-header-div d-flex justify-content-between align-items-center height-25">
                    <div className="d-flex align-items-center position-relative">
                      <img
                        className="invisible ic ic-19"
                        id="lock-image"
                        src={unlocked}
                        alt="lock-icon"
                        style={{ cursor: "pointer" }}
                      />
                      <img
                        id="lock-image"
                        className="ic ic-19 lock-icon"
                        src={unlocked}
                        alt="lock-icon"
                        onClick={(e) => {
                          e.stopPropagation();
                          lockAllFees("draft1", "false");
                        }}
                        style={{ cursor: "pointer" }}
                      />
                      <img
                        id="unlock-image"
                        className="ic ic-19 lock-icon"
                        alt="lock-icon"
                        src={draftLocked}
                        onClick={(e) => {
                          e.stopPropagation();
                          lockAllFees("draft1", "true");
                        }}
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                    <span
                      className="d-flex align-items-center justify-content-end position-relative center-val-div draft-central-div"
                      style={{ paddingRight: "2px" }}
                    >
                      {feesLocks?.some(
                        (lock) =>
                          lock.isDraftLocked && !lock.isFinalLocked && !hasSettlementCheck(lock)
                      ) && <CopyValueSettlement />}
                      <span className="position-absolute right-0">Draft</span>
                    </span>
                  </div>
                </th>
                <th className="s-final text-end" style={{ color: "var(--primary-25) !important" }}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                      <img
                        className="invisible ic ic-19"
                        id="lock-image"
                        src={unlocked}
                        alt="lock-icon"
                        style={{ cursor: "pointer" }}
                      />
                      <img
                        id="lock-image"
                        className="ic ic-19"
                        src={unlocked}
                        alt="lock-icon"
                        onClick={(e) => {
                          e.stopPropagation();
                          lockAllFees("final", "false");
                        }}
                        style={{ cursor: "pointer" }}
                      />
                      <img
                        id="unlock-image"
                        className="ic ic-19"
                        alt="lock-icon"
                        src={locked}
                        onClick={(e) => {
                          e.stopPropagation();
                          lockAllFees("final", "true");
                        }}
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                    <span style={{ paddingRight: "2px" }}>Final</span>
                  </div>
                </th>
                <th className="s-verify" />
                <th
                  className="td-autosize  check-request--btn-settle text-center"
                  style={{ color: "var(--primary-25) !important" }}
                >
                  Check
                </th>
              </tr>
            </thead>
            <tbody id="body-table">
              {fees?.length === 0 && (
                <tr id="cost-settle-row" className="add-btn-row cursor-default">
                  <td className="text=center cursor-pointer" colSpan={15}>
                    <div className="settle-add-btn btn">
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowSettlementPopup(true);
                        }}
                        className="btn"
                      >
                        <span className="fw-bold text-gold">+ </span>
                        <span>Firm Fee</span>
                      </button>
                    </div>
                  </td>
                </tr>
              )}
              {fees?.length > 0 &&
                fees?.map((fee, index) => {
                  const by = fee?.offer?.by_entity_client
                    ? `${fee?.offer?.by_entity_client.first_name || ""} ${fee?.offer?.by_entity_client.last_name || ""}`
                    : fee?.offer?.by_defendant?.defendantType?.id === 1
                      ? `${fee?.offer?.by_defendant?.first_name || ""} ${fee?.offer?.by_defendant?.last_name || ""}`
                      : `${fee?.offer?.by_defendant?.entity_name || ""}`;

                  const party = fee?.offer?.entity_client
                    ? `${fee?.offer?.entity_client.first_name || ""} ${fee?.offer?.entity_client.last_name || ""}`
                    : fee?.offer?.defendant?.defendantType?.id === 1
                      ? `${fee?.offer?.defendant?.first_name || ""} ${fee?.offer?.defendant?.last_name || ""}`
                      : `${fee?.offer?.defendant?.entity_name || ""}`;
                  return (
                    fee?.offer && (
                      <tr
                        key={index}
                        className="cursor-default"
                        onClick={() => {
                          if (hasSettlementCheck(feesLocks[index])) {
                            // handleCheckedRowClick(e);
                            return;
                          }
                          setCurrentFee(fee);
                          setModalAction("EDIT");
                          setCurrentCombination(feesCombinationList[0]);
                          handleFeeShow();
                        }}
                      >
                        <td className="">{offer_num++}</td>
                        <td className="td-autosize">
                          <div className="d-flex align-items-center">
                            <span className="m-r-5">{formatDate(fee?.last_edited)}</span>
                            {/* <div className="d-flex align-items-center">
                              {fee?.offer?.firm_user?.profile_pic_29p ? (
                                <img
                                  src={fee?.offer?.firm_user?.profile_pic_29p}
                                  className="ic ic-15"
                                  style={{ borderRadius: "50%" }}
                                />
                              ) : (
                                <span className="ic ic-avatar-grey ic-15 has-avatar-icon has-cover-img" />
                              )}
                              <span className="m-l-5">
                                {fee?.offer?.firm_user?.first_name}{" "}
                                {fee?.offer?.firm_user?.last_name}
                              </span>
                            </div> */}
                            <UserChatBubble
                              userId={fee?.offer?.firm_user?.id}
                              first_name={fee?.offer?.firm_user?.first_name}
                              last_name={fee?.offer?.firm_user?.last_name}
                              profilePic={fee?.offer?.firm_user?.profile_pic_29p ?? ""}
                              is_active={fee?.offer?.firm_user?.is_active}
                              width={19}
                              isActive={
                                userOnlineStatus?.[fee?.offer?.firm_user?.id]?.isOnline ?? false
                              }
                            />
                          </div>
                        </td>
                        {/* <td className="td-autosize height-33">
                                        <CurrentUserInfo id={fee?.last_edited_by} />
                                    </td> */}
                        <td className="td-autosize" colSpan={5}>
                          <div className="d-flex align-items-center">
                            <div className="d-flex align-items-center">
                              <div className="d-flex align-items-center">
                                <i
                                  className={`ic ic-15 m-r-5 ${fee?.offer?.entity_client ? "ic-client" : "ic-defendants"}`}
                                />

                                <span className="m-r-5">{party}</span>
                                <span
                                  style={{
                                    color: "var(--primary-25)",
                                  }}
                                  className="m-r-5"
                                >
                                  vs
                                </span>
                                <i
                                  className={`ic ic-15 ${fee?.offer?.by_entity_client ? "ic-client" : "ic-defendants"}`}
                                />
                                <span className="m-l-5 m-r-5">{by}</span>
                                {/* <i className="ic ic-15 ic-insurance m-r-5" />
                                {!fee?.offer?.by_entity_client && (
                                  <span>
                                    {fee?.offer?.by_defendant
                                      ? fee?.offer?.by_insurance?.company
                                      : fee?.offer?.insurance?.company}
                                  </span>
                                )} */}
                              </div>
                              <div className="d-flex align-items-center m-l-5">
                                <span
                                  className="text-end monospace-font dollar-amount-value"
                                  // data-value={
                                  //   fee.offer?.demand && fee.offer?.demand === 0
                                  //     ? fee.offer?.amount || 0.0
                                  //     : fee.offer?.demand || 0.0
                                  // }
                                >
                                  {/* {currencyFormat(
                                    fee?.offer?.offer_type?.id === 8
                                      ? fee?.offer?.demand || 0.0
                                      : fee?.offer?.amount || 0.0
                                  )} */}
                                </span>
                              </div>
                            </div>
                            <div className="d-flex align-items-center">
                              <span className="m-l-5">{fee?.percentage || 0} %</span>
                            </div>
                          </div>
                        </td>
                        {/* <td className="td-autosize height-33">{fee?.offer?.insurance?.company}</td> */}
                        {/* <td className="text-end monospace-font td-autosize dollar-amount-value"></td> */}
                        {/* <td className="td-autosize">{fee?.percentage || 0} %</td> */}
                        <td className="td-autosize text-start">{fee?.note}</td>
                        <td className="" />
                        <td className="" />
                        <td
                          className={`monospace-font  dollar-amount-value td-autosize text-end ${!feesLocks[index].isDraftLocked && !hasSettlementCheck(feesLocks[index]) ? "cursor-pointer" : ""}`}
                          data-value={fee.amount || 0.0}
                        >
                          <span
                            className={`d-flex align-items-center ${!feesLocks[index].isDraftLocked && !hasSettlementCheck(feesLocks[index]) ? "justify-content-between cursor-pointer" : "justify-content-end"} align-items-center position-relative center-val-div`}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (hasSettlementCheck(feesLocks[index])) {
                                handleCheckedRowClick(e);
                                return;
                              }
                              updateRightColumnValue(
                                feesLocks[index].isDraftLocked,
                                feesLocks[index].isFinalLocked,
                                setFeesLocks,
                                "fee-draft",
                                fee.id,
                                feesLockValues,
                                setFeesLockValues,
                                "fees",
                                "draft1",
                                fee.amount || 0.0
                              );
                              updateFeesState();
                              clientProceeds.updateClientProceedsState();
                            }}
                          >
                            {!feesLocks[index].isDraftLocked &&
                              !hasSettlementCheck(feesLocks[index]) && <CopyValueSettlement />}
                            {currencyFormat(fee.amount || 0.0)}
                          </span>
                        </td>
                        <td
                          className={"s-draft text-end"}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (hasSettlementCheck(feesLocks[index])) {
                              handleCheckedRowClick(e);
                              return;
                            }
                            updateRightColumnValue(
                              feesLocks[index].isDraftLocked,
                              feesLocks[index].isFinalLocked,
                              setFeesLocks,
                              "fee-final",
                              fee.id,
                              feesLockValues,
                              setFeesLockValues,
                              "fees",
                              "final",
                              feesLocks[index].isDraftAmount
                            );
                            updateFeesState();
                            clientProceeds.updateClientProceedsState();
                          }}
                        >
                          <div className="monospace-font d-flex justify-content-between align-items-center height-25 position-relative center-val-div">
                            <span>
                              {!hasSettlementCheck(feesLocks[index]) && (
                                <img
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleDraftLockChange(fee.id, "fees", e);
                                  }}
                                  id="lock-image"
                                  className="ic ic-15"
                                  src={feesLocks[index]?.isDraftLocked ? draftLocked : unlocked}
                                  alt="lock-icon"
                                  style={{ cursor: "pointer" }}
                                />
                              )}
                            </span>
                            <SettlementCurrencyInput
                              id="lock-input"
                              className={`${feesLocks[index].isDraftLocked && !feesLocks[index].isFinalLocked ? "cursor-pointer" : ""} monospace-font text-end fee-draft-${fee.id} fee-draft dollar-amount-value ${feesLocks[index].isDraftLocked ? "locked-input" : "unlock-input"}`}
                              value={fee.draft1}
                              readOnly={
                                feesLocks[index].isDraftLocked ||
                                hasSettlementCheck(feesLocks[index])
                              }
                              onClick={(e) => {
                                if (hasSettlementCheck(feesLocks[index])) {
                                  handleCheckedRowClick(e);
                                  return;
                                }
                                e.target.focus();
                              }}
                              onLocalChange={({ dataValue }) => {
                                if (hasSettlementCheck(feesLocks[index])) return;
                                setFeesLocks((prevStates) =>
                                  prevStates.map((row) =>
                                    row.id === fee.id ? { ...row, isDraftAmount: dataValue } : row
                                  )
                                );
                                const sum = getSettlementCurrencyInputSum("fee-draft");
                                setFeesLockValues((prevValues) => [sum, prevValues[1]]);
                              }}
                              onDebouncedCommit={async ({ submitValue }) => {
                                if (hasSettlementCheck(feesLocks[index])) return;
                                await updateLockSettleAmount(fee.id, "fees", "draft1", submitValue);
                                updateFeesState();
                                updateClientProceedsState();
                              }}
                              onMouseEnter={(e) => {
                                if (
                                  feesLocks[index].isDraftLocked &&
                                  !feesLocks[index].isFinalLocked
                                ) {
                                  const container = e.currentTarget.closest(".center-val-div");
                                  const lockImg = container?.querySelector("#lock-image");
                                  const copyElement = container?.querySelector(
                                    ".copy-centered-draft, .copy-centered-final, .copy-centered"
                                  );
                                  if (lockImg) {
                                    lockImg.style.opacity = 0;
                                    lockImg.style.zIndex = 0;
                                  }
                                  if (copyElement) {
                                    copyElement.style.opacity = 1;
                                    copyElement.style.zIndex = 1;
                                    copyElement.style.cursor = "pointer";
                                    copyElement.style.display = "flex";
                                  }
                                }
                              }}
                              onMouseLeave={(e) => {
                                if (
                                  feesLocks[index].isDraftLocked &&
                                  !feesLocks[index].isFinalLocked
                                ) {
                                  const container = e.currentTarget.closest(".center-val-div");
                                  const lockImg = container?.querySelector("#lock-image");
                                  const copyElement = container?.querySelector(
                                    ".copy-centered-draft, .copy-centered-final, .copy-centered"
                                  );
                                  if (lockImg) {
                                    lockImg.style.opacity = 1;
                                    lockImg.style.zIndex = 1;
                                  }
                                  if (copyElement) {
                                    copyElement.style.opacity = 0;
                                    copyElement.style.zIndex = 0;
                                    copyElement.style.cursor = "initial";
                                    copyElement.style.display = "none";
                                  }
                                }
                              }}
                              style={{ zIndex: 2 }}
                            />
                            {feesLocks[index].isDraftLocked &&
                              !feesLocks[index].isFinalLocked &&
                              !hasSettlementCheck(feesLocks[index]) && (
                                <CopyValueSettlement draft={true} />
                              )}
                          </div>
                        </td>
                        <td className="s-final text-end">
                          <div
                            // onMouseEnter={() => setIsHovered({ id: fee?.id, value: true })}
                            // onMouseLeave={() => setIsHovered({ id: fee?.id, value: false })}
                            className="monospace-font d-flex justify-content-between align-items-center height-25 position-relative center-val-div"
                          >
                            <span>
                              {!hasSettlementCheck(feesLocks[index]) && (
                                <img
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleFinalLockChange(fee.id, "fees", e);
                                  }}
                                  id="lock-image"
                                  className={`ic ic-15 ${feesLocks[index].checkID?.check_sent ? "invisible" : ""} `}
                                  src={
                                    feesLocks[index]?.isFinalLocked
                                      ? feesLocks[index]?.checkID?.check_sent
                                        ? lockedGrey
                                        : locked
                                      : feesLocks[index]?.checkID?.check_sent
                                        ? unlockedGrey
                                        : unlocked
                                  }
                                  alt="lock-icon"
                                  style={{ cursor: "pointer" }}
                                  // onMouseEnter={() => setIsHovered({ id: fee?.id, value: false })}
                                  // onMouseLeave={() => setIsHovered({ id: fee?.id, value: true })}
                                />
                              )}
                            </span>
                            <SettlementCurrencyInput
                              id="lock-input"
                              className={`${!feesLocks[index].checkID && feesLocks[index].isFinalLocked ? "cursor-pointer" : ""} monospace-font bill-final-${fee.id} monospace-font text-end fee-final-${fee.id} fee-final dollar-amount-value ${feesLocks[index].isFinalLocked ? "locked-input" : "unlock-input"}`}
                              value={fee.final}
                              readOnly={
                                feesLocks[index].isFinalLocked ||
                                hasSettlementCheck(feesLocks[index])
                              }
                              onClick={async (e) => {
                                e.stopPropagation();
                                if (hasSettlementCheck(feesLocks[index])) {
                                  handleCheckedRowClick(e);
                                  return;
                                }
                                e.target.focus();
                              }}
                              onLocalChange={({ dataValue }) => {
                                if (hasSettlementCheck(feesLocks[index])) return;
                                setFeesLocks((prevStates) =>
                                  prevStates.map((row) =>
                                    row.id === fee.id ? { ...row, isFinalAmount: dataValue } : row
                                  )
                                );
                                const sum = getSettlementCurrencyInputSum("fee-final");
                                setFeesLockValues((prevValues) => [prevValues[0], sum]);
                              }}
                              onDebouncedCommit={async ({ submitValue }) => {
                                if (hasSettlementCheck(feesLocks[index])) return;
                                await updateLockSettleAmount(fee.id, "fees", "final", submitValue);
                                updateFeesState();
                                updateClientProceedsState();
                              }}
                            />
                            {!feesLocks[index].checkID && feesLocks[index].isFinalLocked && (
                              <CopyValueSettlement draft={true} final={true} />
                            )}
                          </div>
                        </td>
                        <td className="s-verify" onClick={(e) => e.stopPropagation()}>
                          <ChequeUpload
                            entity={fee}
                            panel={"fee"}
                            pageId={page_id_click_record}
                            documentType="verify"
                            updateStates={updateFeesState}
                            handleNoCheckShow={handleNoCheckShow}
                          />
                        </td>
                        <td
                          className="td-autosize text-center "
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div
                            className={`${feesLocks[index]?.checkID?.cheque_number ? "check-class" : "d-flex justify-content-center"} `}
                          >
                            {!feesLocks[index].checkID &&
                            feesLocks[index].isFinalLocked &&
                            hasNonZeroSettlementAmount(feesLocks[index].isFinalAmount) ? (
                              <div className="d-flex align-items-center justify-content-center">
                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (feesLocks[index].isFinalLocked) {
                                      setCurrentFee({
                                        ...fee,
                                        final: feesLocks[index].isFinalAmount,
                                      });
                                      setCheckRequestModal(true);
                                    }
                                  }}
                                  className="settle-check-request-btn btn"
                                  id="nomargin"
                                  style={{
                                    color: "white",
                                    fontWeight: "600",
                                    background: "#009900",
                                  }}
                                >
                                  <p className={"font-weight-semibold"}>Request Check</p>
                                </div>
                              </div>
                            ) : (
                              <SettlementCheckDetails
                                entity={fee}
                                check={feesLocks[index].checkID}
                                pageId={page_id_click_record}
                                updateStates={updateFeesState}
                                handleNoCheckShow={handleNoCheckShow}
                              />
                            )}
                          </div>
                        </td>
                      </tr>
                    )
                  );
                })}
              {fees?.length > 0 && (
                <tr className="cursor-default">
                  <td />
                  <td className="height-25 text-capitalize text-end" colSpan={10}>
                    <span className="whitespace-SETTLE primary-clr-25">Total Fees: </span>
                    <p
                      className="d-inline-flex align-items-center height-25 monospace-font text-end fw-bold dollar-amount-value"
                      data-value={feesFinalAmount || 0.0}
                    >
                      {currencyFormat(feesFinalAmount || 0.0)}
                    </p>
                  </td>
                  <td className="s-draft monospace-font text-end">
                    <span
                      style={{ paddingRight: "2px" }}
                      data-value={feesLockValues[0] || 0.0}
                      className="dollar-amount-value"
                    >
                      {currencyFormat(feesLockValues[0] || 0.0)}
                    </span>
                  </td>
                  <td className="s-final monospace-font text-end">
                    <span
                      style={{ paddingRight: "2px" }}
                      data-value={feesLockValues[1] || 0.0}
                      className="dollar-amount-value"
                    >
                      {currencyFormat(feesLockValues[1] || 0.0)}
                    </span>
                  </td>
                  <td className="verify" />
                  <td className="td-autosize text-center" />
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {showFeeModal && (
        <EditFeesPopup
          show={showFeeModal}
          fee={modalAction === "EDIT" ? currentFee : {}}
          currentCombination={currentCombination}
          handleClose={handleFeeClose}
          feesPercentages={feesPercentages}
          amount={feesFinalAmount}
          action={modalAction}
          feesCombinationList={feesCombinationList}
          setData={setFees}
          updateFeesState={updateFeesState}
          initialOffers={initialOffers}
        />
      )}
      {showSettlementPopup && (
        <GenericSettlementAddPopup
          show={showSettlementPopup}
          handleClose={() => {
            setShowSettlementPopup(false);
          }}
          _initialLabel={"Firm Fee"}
          {...settlementObjProps}
        />
      )}
      {showErrorModal && (
        <SettlementErrorModal
          show={showErrorModal}
          handleClose={handleErrorClose}
          errorMsg={errorMsg}
          updateStates={updateFeesState}
        />
      )}
      {showNoCheckModal && (
        <SettlementNoCheckModal show={showNoCheckModal} handleClose={handleNoCheckClose} />
      )}
      {checkAlreadyRequested && (
        <CheckAlreadyRequestedModal
          show={checkAlreadyRequested}
          hideModal={handleCheckAlreadyRequestedClose}
        />
      )}
      {showCheckRequestModal && (
        <SettlementCheckRequest
          show={showCheckRequestModal}
          handleClose={handleCheckRequestClose}
          finalAmount={currentFee?.final}
          panelLabel={"Fees"}
          panelName={"fees"}
          panelEntity={currentFee}
          updateStates={() => {
            updateFeesState();
            updateClientProceedsState();
          }}
        />
      )}
    </>
  );
};

export default OffersFeeTable;
